export function trackTalkSessionAdd(eventName, res, extra = {}) {
  try {
    if (window.staticFn) {
      window.staticFn.customEvent(eventName, {
        resJson: JSON.stringify(res),
        ...extra,
      });
    }
  } catch (e) {
    // 埋点失败不阻断后续逻辑
  }
}
